export enum BillingUnit {
  BOTTE = 'Botte',
  CARTON = 'Carton',
  KG = 'Kg',
  LITRE = 'Litre',
  LOT = 'Lot',
  M2 = 'M2',
  M3 = 'M3',
  METRE = 'Mètre',
  PANNEAU = 'Panneau',
  ROULEAU = 'Rouleau',
  UNITE = 'Unité'
}

export function getBillingUnitLabel(unit: string): string {
  if (unit in BillingUnit) {
    return BillingUnit[unit as keyof typeof BillingUnit];
  }

  return unit;
}
